import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import ChiTietHopDong from "../../../../../../service/chiTietHopDongApi";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
export const BtnChiTietHopDong = ({ item }) => {
  console.log(item);
  const [showChiTietHopDong, setShowChiTietHopDong] = useState(false);
  const handleCloseChiTietHopDong = () => setShowChiTietHopDong(false);
  const handleShowChiTietHopDong = () => setShowChiTietHopDong(true);

  const objChiTietHopDong = {};
  const [chovayChiTiet, setChoVay] = useState(objChiTietHopDong);

  const timkiemHopDong = { choVayId: 0 };

  const functionChiTietChoVay = () => {
    timkiemHopDong.choVayId = item.ChoVayId;
    ChiTietHopDong.getChiTietHopDong1(item.ChoVayId).then((response) => {
      setChoVay(response.data);
      setShowChiTietHopDong(true);
    });
  };
  return (
    <>
      <a onClick={functionChiTietChoVay} href={() => false} className="blue btn-link">
        {item.Code}
      </a>
      {showChiTietHopDong && (
        <ChiTietHopDongContainer
          show={handleShowChiTietHopDong}
          onHide={handleCloseChiTietHopDong}
          data={chovayChiTiet}
          setModalTaiSan={handleShowChiTietHopDong}
        ></ChiTietHopDongContainer>
      )}
    </>
  );
};
